export default __webpack_public_path__ + "static/media/gurgaon-01.c1ef7cfa.webp";